// Storefront code/name -> currency symbol. Add new storefronts here as they launch.
const STOREFRONT_CURRENCY_MAP = {
  US: '$',
  UAT: '$',
  INT: '€',
  EU: '€',
  UK: '£',
  DE: '€',
  WW3MSIYLZO: '$',
  EB52P33WQ0: '$',
  DWDWR5MARW: '€',
  H658UHFY9J: '£',
  LLMY6CYSH9: '€',
};

const DEFAULT_CURRENCY_SYMBOL = '$';

export const getCurrencySymbolForStore = (storeName, fallback = DEFAULT_CURRENCY_SYMBOL) => {
  const key = String(storeName || '').trim().toUpperCase();
  return STOREFRONT_CURRENCY_MAP[key] || fallback;
};

export default getCurrencySymbolForStore;
